import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createContactsResource } from '@atlassian/eoc-contact-methods/resources';
import {
	createMuteResource,
	createQuietHoursResource,
} from '@atlassian/eoc-mute-quiet-hours/resources';
import {
	createNotificationPreferencesResource,
	createForwardingRulesResource,
} from '@atlassian/eoc-notifications/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocUserNotificationsRoute } from '@jira/router-routes__eoc-user-notifications-routes/src/eocUserNotificationsRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import UserNotifications, {
	LazyUserNotifications,
} from './ui/spa/eoc/user-notifications/index.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocUserNotificationsRouteEntry: Route = createEntry(eocUserNotificationsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: UserNotifications,
	layout: opsSettingsLayout,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		createContactsResource(),
		createNotificationPreferencesResource(),
		createMuteResource(),
		createQuietHoursResource(),
		createForwardingRulesResource(),
		navigationSidebarGlobalResource,
	],

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyUserNotifications],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
